import React from "react";

const ManagePrint = ({
  Requirework,
  Result,
  Notes,
  Description,
  MenueWork,
  GehaWork,
  Datee,
}) => {
  return (
    <>
      <div id="printt">
      <h3 className="text-center m-3">بيانات العمل الإداري</h3>

        <p>
          <span>التاريخ: </span>
          {new Date(Datee).toLocaleDateString("en-GB")}
        </p>
        <p>
          <span>العمل المطلوب: </span>
          {Requirework}
        </p>
        <p>
          <span>جهة العمل: </span>
          {GehaWork}
        </p>
        <p>
          <span>القائم بالعمل: </span>
          {MenueWork}
        </p>
        <p>
          <span>النتيجة: </span>
          {Result}
        </p>
        <p>
          <span>ملاحظات : </span>
          {Notes}
        </p>
      </div>
    </>
  );
};

export default ManagePrint;
